import { Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
import { OnboardingModal } from './OnboardingModal';
import { meApi } from '../api/endpoints';
import type { UserDto } from '../api/types';

/**
 * Layout commun à toutes les pages authentifiées.
 * Charge le profil utilisateur (qui sert aussi à l'auto-provisionnement
 * côté backend lors du 1er appel).
 *
 * Si l'utilisateur n'a jamais validé son profil (IsProfileSetup=false),
 * on affiche une modal bloquante qui force la saisie de l'agence et du statut.
 */
export function AppLayout() {
  const [user, setUser] = useState<UserDto>();

  const refreshUser = () => meApi.get().then(r => setUser(r.user));

  useEffect(() => {
    refreshUser().catch(err => console.error('me failed', err));
  }, []);

  // Tant qu'on n'a pas l'user, on n'affiche rien (évite un flash) — sauf un
  // simple skeleton si vraiment l'API met du temps.
  if (!user) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center text-ink-sub text-sm">
        Chargement…
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header user={user} />
      <main className="max-w-3xl mx-auto pb-24 px-4 sm:px-6">
        <Outlet context={{ user, refreshUser }} />
      </main>
      <BottomNav />

      {/* Onboarding bloquant au premier login */}
      {!user.isProfileSetup && (
        <OnboardingModal user={user} onDone={refreshUser} />
      )}
    </div>
  );
}
